<p-drawer [visible]="visible()" (visibleChange)="onVisibleChange($event)" position="right" [style]="{ width: '100%', maxWidth: width() }" [modal]="true"
    [dismissible]="true" [showCloseIcon]="false" (onHide)="onClose()" styleClass="filters-drawer">

    <ng-template pTemplate="header">
        <div class="flex items-center justify-between w-full py-2">
            <div class="flex items-center gap-2">
                <span class="material-icons text-primary dark:text-blue-400 text-lg">settings</span>
                <div>
                    <h2 class="text-base font-bold text-gray-900 dark:text-gray-100">{{ title() }}</h2>
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ subtitle() }}</p>
                </div>
            </div>
            <button (click)="onClose()"
                class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer">
                <span class="material-icons text-gray-500 dark:text-gray-400 text-lg">close</span>
            </button>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="p-3">
            <ng-content></ng-content>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex flex-col gap-2 p-6 border-t border-gray-200 dark:border-gray-700">
            <!-- Botón Aplicar Filtros -->
            <button (click)="onApply()" [disabled]="disableApply()"
                class="w-full py-2 bg-primary hover:bg-primary-700 text-white font-semibold rounded-md transition-all duration-200 flex items-center justify-center gap-1.5 shadow-sm hover:shadow-md active:scale-[0.98] text-sm cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="material-icons" style="font-size: 16px;">search</span>
                Aplicar Filtros
            </button>

            <!-- Botón Limpiar -->
            <button (click)="onClear()" [disabled]="disableClear()"
                class="w-full py-2 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 font-medium rounded-md border border-gray-300 dark:border-gray-600 transition-all duration-200 flex items-center justify-center gap-1.5 active:scale-[0.98] text-sm cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="material-icons" style="font-size: 16px;">close</span>
                Limpiar
            </button>
        </div>
    </ng-template>
</p-drawer>